import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-dynamic-form-list',
	standalone: false,
	templateUrl: './dynamic-form-list.component.html',
	styleUrl: './dynamic-form-list.component.scss',
})
export class DynamicFormListComponent {
	constructor(private router: Router) {}

	add(): void {
		this.router.navigate(['/form/new']);
	}
}
